// import { useState, useCallback, useEffect, useRef } from "react";
// import { ShoppingCart, Check, Star, Eye, TrendingUp, Sparkles } from "lucide-react";
// import ProductsApiService from "../../services/ProductsApiService";
// import "./HeroTrendingProductSlider.scss";
// import { useNavigate } from "react-router-dom";
// import { getLanguage } from "../../utils/Helper";
// import { useCart } from "../../context/CartContext";
// import { toast } from "react-toastify";
// import WishlistButton from "../general/wishlistButton/WishlistButton";

// const HeroTrendingProductSlider = () => {
//   const [products, setProducts] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [isAddingToCart, setIsAddingToCart] = useState({});
//   const [showSuccess, setShowSuccess] = useState({});
//   const containerRef = useRef(null);

//   const navigate = useNavigate();
//   const lang = getLanguage();
  
//   const { addToCart, removeFromCart, isInCart } = useCart();

//   // ─── Fetch ────────────────────────────────────────────
//   const fetchTrendedProducts = async () => {
//     try {
//       setLoading(true);
//       const response = await ProductsApiService.fetchTrendedProducts();
//       setProducts(response);
//     } catch (err) {
//       console.error("Error fetching products:", err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchTrendedProducts();
//   }, []);

//   // ─── Navigation Functions ─────────────────────────────
//   const scrollToDirection = (direction) => {
//     const container = containerRef.current;
//     if (!container) return;

//     const scrollAmount = container.clientWidth * 0.8;
//     const newPosition = direction === 'left' 
//       ? container.scrollLeft - scrollAmount 
//       : container.scrollLeft + scrollAmount;

//     container.scrollTo({
//       left: newPosition,
//       behavior: 'smooth'
//     });
//   };

//   const handlePrevious = () => scrollToDirection('left');
//   const handleNext = () => scrollToDirection('right');

//   // ─── Product profile URL ──────────────────────────────
//   const openProductProfile = (product) => {
//     const collectionName = product.collectionNameEn
//       .toString()
//       .toLowerCase()
//       .trim()
//       .split(" ")
//       .join("-");
//     const catName = product.categoryNameEn
//       .toString()
//       .toLowerCase()
//       .trim()
//       .split(" ")
//       .join("-");
//     const subCatName = product.subCategoryNameEn
//       .toString()
//       .toLowerCase()
//       .trim()
//       .split(" ")
//       .join("-");
//     navigate(
//       `/collection/${collectionName}/${catName}/${subCatName}/${product.id}`,
//     );
//   };

//   // ─── Description truncate ────────────────────────────
//   const handleProductDesc = (desc) => {
//     return desc?.length > 100 ? `${desc.substring(0, 100)}...` : desc;
//   };

//   // ─── Colors من variants ───────────────────────────────
//   const getUniqueColors = (product) => {
//     if (!product.variants || product.variants.length === 0) return [];
//     const colors = product.variants
//       .map((v) => v.color)
//       .filter((col) => col && col.hexCode);
//     return colors.filter(
//       (color, index, self) =>
//         index === self.findIndex((c) => c.hexCode === color.hexCode),
//     );
//   };

//   const getAvailableVariant = (product) => {
//     if (!product.variants || product.variants.length === 0) return null;
//     return (
//       product.variants.find((v) => {
//         return v.isActive && 
//           ((v.quantity - v.reservedQuantity > 0) || (v.withoutBoxQuantity - v.withoutBoxReservedQuantity > 0));
//       }) ||
//       product.variants[0]
//     );
//   };

//   const isOutOfStock = (product) => {
//     if (!product.variants || product.variants.length === 0) return true;
//     return !product.variants.some((v) => {
//       return v.isActive && 
//         ((v.quantity - v.reservedQuantity > 0) || (v.withoutBoxQuantity - v.withoutBoxReservedQuantity > 0));
//     });
//   };

//   // ✅ NEW: Handle Add/Remove from Cart
//   const handleCartAction = useCallback(
//     async (e, product) => {
//       e.preventDefault();
//       e.stopPropagation();

//       const variant = getAvailableVariant(product);
//       if (!variant || isAddingToCart[product.id] || isOutOfStock(product)) return;

//       const isWithoutBox = (variant.quantity - variant.reservedQuantity) <= 0;
      
//       const productInCart = isInCart(variant.id, isWithoutBox);

//       if (productInCart) {
//         setIsAddingToCart((prev) => ({ ...prev, [product.id]: true }));
        
//         try {
//           await removeFromCart(product.id, variant.id, isWithoutBox);
          
//           toast.success(
//             lang === "EN"
//               ? "Removed from cart!"
//               : "تم الحذف من السلة!",
//             {
//               position: lang === "AR" ? "top-right" : "top-left",
//               autoClose: 2000,
//             }
//           );
//         } catch (error) {
//           toast.error(
//             lang === "EN"
//               ? "Error removing from cart"
//               : "خطأ في حذف المنتج",
//           );
//         } finally {
//           setIsAddingToCart((prev) => ({ ...prev, [product.id]: false }));
//         }
//       } else {
//         // المنتج مش موجود - اضيفه للـ cart
//         setIsAddingToCart((prev) => ({ ...prev, [product.id]: true }));
//         setShowSuccess((prev) => ({ ...prev, [product.id]: false }));

//         try {
//           const cartProduct = {
//             id: product.id,
//             nameEn: product.nameEn,
//             nameAr: product.nameAr,
//             descriptionEn: product.descriptionEn,
//             descriptionAr: product.descriptionAr,
//             images: [{ image_url: product.imageUrl }],
//             brand: {
//               nameEn: product.brandNameEn,
//               nameAr: product.brandNameAr,
//             },
//             collection: { nameEn: product.collectionNameEn },
//             category: { nameEn: product.categoryNameEn },
//             subCategory: { nameEn: product.subCategoryNameEn },
//           };

//           const cartVariant = {
//             id: variant.id,
//             price: variant.price,
//             discountPrice: variant.discountPrice || null,
//             quantity: (variant.quantity - variant.reservedQuantity) || 0,
//             withoutBoxQuantity: (variant.withoutBoxQuantity - variant.withoutBoxReservedQuantity) || 0,
//             color: variant.color || null,
//             size: variant.size || null,
//             sku: variant.sku || "",
//           };

//           await addToCart(cartProduct, cartVariant, 1, isWithoutBox, false);

//           // setShowSuccess((prev) => ({ ...prev, [product.id]: true }));
          
//           // setTimeout(() => {
//             // setShowSuccess((prev) => ({ ...prev, [product.id]: false }));
//           // }, 2000);
//         } catch (error) {
//           toast.error(
//             lang === "EN"
//               ? "Something went wrong while adding to cart"
//               : "حدث خطأ أثناء إضافة المنتج للسلة",
//           );
//         } finally {
//           setIsAddingToCart((prev) => ({ ...prev, [product.id]: false }));
//         }
//       }
//     },
//     [isAddingToCart, addToCart, removeFromCart, isInCart, lang],
//   );

//   // ─── Product Card Component ──────────────────────────
//   const ProductCard = ({ product, index }) => {
//     const uniqueColors = getUniqueColors(product);
//     const outOfStock = isOutOfStock(product);
//     const availableVariant = getAvailableVariant(product);
    
//     // ✅ تحقق إذا المنتج في الـ cart
//     const isWithoutBox = availableVariant 
//       ? (availableVariant.quantity - availableVariant.reservedQuantity) <= 0 
//       : false;
//     const productInCart = availableVariant 
//       ? isInCart(availableVariant.id, isWithoutBox) 
//       : false;

//     return (
//       <div
//         key={`${product.id}-${index}`}
//         className="product-card"
//         onClick={() => openProductProfile(product)}
//         style={{ animationDelay: `${index * 0.1}s` }}
//       >
//         {/* Image */}
//         <div className="card-image-wrapper">
//           <div className="trending-badge">
//             <Star size={14} fill="currentColor" />
//             <span>{lang === "EN" ? "Trend" : "ترند"}</span>
//           </div>

//           {/* Wishlist Button */}
//           {availableVariant && (
//             <div
//               className="wishlist-button-wrapper"
//               onClick={(e) => {
//                 e.preventDefault();
//                 e.stopPropagation();
//               }}
//             >
//               <WishlistButton
//                 productVariantId={availableVariant.id}
//                 className="card-wishlist-btn"
//               />
//             </div>
//           )}

//           {product.discountPrice &&
//             product.discountPrice !== product.price && (
//               <div className="discount-badge">
//                 -
//                 {Math.round(
//                   ((product.price - product.discountPrice) /
//                     product.price) *
//                     100,
//                 )}
//                 %
//               </div>
//             )}

//           {outOfStock && (
//             <div className="out-of-stock-overlay">
//               <span>
//                 {lang === "EN" ? "Out of Stock" : "غير متوفر"}
//               </span>
//             </div>
//           )}

//           <img
//             src={product.imageUrl}
//             alt={lang === "EN" ? product.nameEn : product.nameAr}
//             className="card-image"
//           />
//         </div>

//         {/* Content */}
//         <div className="card-content">
//           {product.brandImageUrl && (
//             <div className="brand-logo">
//               <img
//                 src={product.brandImageUrl}
//                 alt={
//                   lang === "EN"
//                     ? product.brandNameEn
//                     : product.brandNameAr
//                 }
//               />
//             </div>
//           )}

//           <div className="category">
//             {lang === "EN"
//               ? product.categoryNameEn
//               : product.categoryNameAr}
//           </div>

//           <h3 className="product-title">
//             {lang === "EN" ? product.nameEn : product.nameAr}
//           </h3>

//           {(product.descriptionEn || product.descriptionAr) && (
//             <p className="product-description">
//               {lang === "EN"
//                 ? handleProductDesc(product.descriptionEn)
//                 : handleProductDesc(product.descriptionAr)}
//             </p>
//           )}

//           {uniqueColors.length > 0 && (
//             <div className="colors-section">
//               <div className="colors-list">
//                 {uniqueColors.slice(0, 5).map((color, idx) => (
//                   <div
//                     key={idx}
//                     className="color-dot"
//                     style={{ 
//                       backgroundColor: color.hexCode,
//                       color: color.hexCode
//                     }}
//                     title={lang === "EN" ? color.nameEn : color.nameAr}
//                   />
//                 ))}
//                 {uniqueColors.length > 5 && (
//                   <div className="more-colors">
//                     +{uniqueColors.length - 5}
//                   </div>
//                 )}
//               </div>
//             </div>
//           )}

//           <div className="price-section">
//             <div className="price-main">
//               {(
//                 product.discountPrice || product.price
//               ).toLocaleString()}
//               <span className="currency">
//                 {lang === "EN" ? "EGP" : "ج.م"}
//               </span>
//             </div>
//             {product.discountPrice &&
//               product.discountPrice !== product.price && (
//                 <div className="price-old">
//                   {product.price.toLocaleString()}{" "}
//                   {lang === "EN" ? "EGP" : "ج.م"}
//                 </div>
//               )}
//           </div>

//           <div className="card-actions">
//             {/* ✅ زرار Add/Remove من Cart */}
//             <button
//               className={`btn-add-cart ${
//                 productInCart ? "in-cart" : ""
//               } ${showSuccess[product.id] ? "success" : ""} ${
//                 isAddingToCart[product.id] ? "loading" : ""
//               } ${outOfStock ? "out-of-stock" : ""}`}
//               onClick={(e) => handleCartAction(e, product)}
//               disabled={isAddingToCart[product.id] || outOfStock}
//             >
//               {showSuccess[product.id] ? (
//                 <>
//                   <Check size={18} strokeWidth={2.5} />
//                   <span>{lang === "EN" ? "Added!" : "تمت!"}</span>
//                 </>
//               ) : isAddingToCart[product.id] ? (
//                 <>
//                   <div className="btn-spinner"></div>
//                   <span>{lang === "EN" ? "Processing..." : "جاري..."}</span>
//                 </>
//               ) : outOfStock ? (
//                 <span>
//                   {lang === "EN" ? "Out of Stock" : "غير متوفر"}
//                 </span>
//               ) : productInCart ? (
//                 <>
//                   <ShoppingCart size={18} strokeWidth={2.5} />
//                   <span>
//                     {lang === "EN" ? "Remove from cart" : " من السلة إزالة"}
//                   </span>
//                 </>
//               ) : (
//                 <>
//                   <ShoppingCart size={18} strokeWidth={2.5} />
//                   <span>
//                     {lang === "EN" ? "Add to Cart" : "أضف للسلة"}
//                   </span>
//                 </>
//               )}
//             </button>

//             <button
//               className="btn-view"
//               onClick={(e) => {
//                 e.stopPropagation();
//                 openProductProfile(product);
//               }}
//             >
//               <Eye size={18} strokeWidth={2.5} />
//             </button>
//           </div>
//         </div>
//       </div>
//     );
//   };

//   // ─── Loading ──────────────────────────────────────────
//   if (loading) {
//     return (
//       <div className="cards-slider-loading">
//         <div className="loading-content">
//           <div className="spinner"></div>
//           <p>
//             {lang === "EN"
//               ? "Loading Trending Products..."
//               : "جاري تحميل المنتجات الرائجة..."}
//           </p>
//         </div>
//       </div>
//     );
//   }

//   if (products.length === 0) {
//     return (
//       <div className="cards-slider-loading">
//         <p>
//           {lang === "EN"
//             ? "No trending products available"
//             : "لا توجد منتجات متاحة"}
//         </p>
//       </div>
//     );
//   }

//   // ─── Render with Manual Navigation ──────────────────────
//   const duplicatedProducts = [...products, ...products];

//   return (
//     <div className="trending-cards-slider" style={{backgroundImage: "url('/assets/black background.jpg')"}}>

//       {/* Header */}
//       <div className="slider-header">
//         <div className="title-section">
//           <TrendingUp className="trending-icon" size={36} strokeWidth={2.5} />
//           <h2 className="slider-title">
//             {lang === "EN" ? "Trending Now" : "الترند الآن"}
//           </h2>
//           <Sparkles className="trending-icon" size={36} strokeWidth={2.5} />
//         </div>
//       </div>

//       {/* Slider Container with Navigation */}
//       <div className="slider-wrapper">
//         {/* Left Navigation Button */}
//         <button 
//           className="nav-button nav-button-left"
//           onClick={handlePrevious}
//           aria-label={lang === "EN" ? "Previous" : "السابق"}
//         >
//           <svg 
//             width="24" 
//             height="24" 
//             viewBox="0 0 24 24" 
//             fill="none" 
//             stroke="currentColor" 
//             strokeWidth="3" 
//             strokeLinecap="round" 
//             strokeLinejoin="round"
//           >
//             <polyline points="15 18 9 12 15 6"></polyline>
//           </svg>
//         </button>

//         {/* Cards Container */}
//         <div className="cards-container" ref={containerRef}>
//           <div className="cards-wrapper">
//             {duplicatedProducts.map((product, index) => (
//               <ProductCard 
//                 key={`product-${index}`} 
//                 product={product} 
//                 index={index}
//               />
//             ))}
//           </div>
//         </div>

//         {/* Right Navigation Button */}
//         <button 
//           className="nav-button nav-button-right"
//           onClick={handleNext}
//           aria-label={lang === "EN" ? "Next" : "التالي"}
//         >
//           <svg 
//             width="24" 
//             height="24" 
//             viewBox="0 0 24 24" 
//             fill="none" 
//             stroke="currentColor" 
//             strokeWidth="3" 
//             strokeLinecap="round" 
//             strokeLinejoin="round"
//           >
//             <polyline points="9 18 15 12 9 6"></polyline>
//           </svg>
//         </button>
//       </div>
//     </div>
//   );
// };

// export default HeroTrendingProductSlider;

import { useState, useCallback, useEffect, useRef } from "react";
import { ShoppingCart, Check, Star, Eye, TrendingUp, Sparkles, ChevronLeft, ChevronRight } from "lucide-react";
import ProductsApiService from "../../services/ProductsApiService";
import "./HeroTrendingProductSlider.scss";
import { useNavigate } from "react-router-dom";
import { getLanguage } from "../../utils/Helper";
import { useCart } from "../../context/CartContext";
import { toast } from "react-toastify";
import WishlistButton from "../general/wishlistButton/WishlistButton";

const HeroTrendingProductSlider = () => {
  const [products, setProducts]         = useState([]);
  const [loading, setLoading]           = useState(true);
  const [isAddingToCart, setIsAddingToCart] = useState({});
  const [showSuccess, ]   = useState({});
  const [canScrollLeft, setCanScrollLeft]   = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(false);

  const containerRef = useRef(null);
  const navigate     = useRef(useNavigate()).current;
  const lang         = getLanguage();
  const { addToCart, removeFromCart, isInCart } = useCart();

  // ─── Fetch ────────────────────────────────────────────
  useEffect(() => {
    (async () => {
      try {
        setLoading(true);
        const response = await ProductsApiService.fetchTrendedProducts();
        setProducts(response);
      } catch (err) {
        console.error("Error fetching products:", err);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  // ─── Scroll arrows visibility ─────────────────────────
  const checkScroll = () => {
    const el = containerRef.current;
    if (!el) return;
    setCanScrollLeft(el.scrollLeft > 4);
    setCanScrollRight(el.scrollLeft + el.clientWidth < el.scrollWidth - 4);
  };

  useEffect(() => {
    const el = containerRef.current;
    if (!el) return;
    checkScroll();
    el.addEventListener("scroll", checkScroll, { passive: true });
    const ro = new ResizeObserver(checkScroll);
    ro.observe(el);
    return () => { el.removeEventListener("scroll", checkScroll); ro.disconnect(); };
  }, [products]);

  const scroll = (dir) => {
    const el = containerRef.current;
    if (!el) return;
    el.scrollBy({ left: dir === "right" ? el.clientWidth * 0.75 : -(el.clientWidth * 0.75), behavior: "smooth" });
  };

  // ─── Helpers ──────────────────────────────────────────
  const openProductProfile = (product) => {
    const slug = (s) => s.toString().toLowerCase().trim().split(" ").join("-");
    navigate(`/collection/${slug(product.collectionNameEn)}/${slug(product.categoryNameEn)}/${slug(product.subCategoryNameEn)}/${product.id}`);
  };

  const truncate = (text, max = 80) =>
    text?.length > max ? `${text.substring(0, max)}...` : text ?? "";

  const getUniqueColors = (product) => {
    if (!product.variants?.length) return [];
    const seen = new Set();
    return product.variants
      .map((v) => v.color)
      .filter((c) => c?.hexCode && !seen.has(c.hexCode) && seen.add(c.hexCode));
  };

  const getAvailableVariant = (product) =>
    product.variants?.find(
      (v) => v.isActive &&
        ((v.quantity - v.reservedQuantity > 0) || (v.withoutBoxQuantity - v.withoutBoxReservedQuantity > 0))
    ) ?? product.variants?.[0] ?? null;

  const isOutOfStock = (product) =>
    !product.variants?.some(
      (v) => v.isActive &&
        ((v.quantity - v.reservedQuantity > 0) || (v.withoutBoxQuantity - v.withoutBoxReservedQuantity > 0))
    );

  // ─── Cart action ──────────────────────────────────────
  const handleCartAction = useCallback(async (e, product) => {
    e.preventDefault();
    e.stopPropagation();
    const variant = getAvailableVariant(product);
    if (!variant || isAddingToCart[product.id] || isOutOfStock(product)) return;

    const isWithoutBox  = (variant.quantity - variant.reservedQuantity) <= 0;
    const productInCart = isInCart(variant.id, isWithoutBox);

    setIsAddingToCart((p) => ({ ...p, [product.id]: true }));
    try {
      if (productInCart) {
        await removeFromCart(product.id, variant.id, isWithoutBox);
        // toast.success(lang === "EN" ? "Removed from cart!" : "تم الحذف من السلة!", {
        //   position: lang === "AR" ? "top-right" : "top-left", autoClose: 2000,
        // });
      } else {
        const cartProduct = {
          id: product.id,
          nameEn: product.nameEn, nameAr: product.nameAr,
          descriptionEn: product.descriptionEn, descriptionAr: product.descriptionAr,
          images: [{ image_url: product.imageUrl }],
          brand: { nameEn: product.brandNameEn, nameAr: product.brandNameAr },
          collection: { nameEn: product.collectionNameEn },
          category: { nameEn: product.categoryNameEn },
          subCategory: { nameEn: product.subCategoryNameEn },
        };
        const cartVariant = {
          id: variant.id,
          price: variant.price,
          discountPrice: variant.discountPrice ?? null,
          quantity: (variant.quantity - variant.reservedQuantity) || 0,
          withoutBoxQuantity: (variant.withoutBoxQuantity - variant.withoutBoxReservedQuantity) || 0,
          color: variant.color ?? null,
          size: variant.size ?? null,
          sku: variant.sku ?? "",
        };
        await addToCart(cartProduct, cartVariant, 1, isWithoutBox, false);
      }
    } catch {
      toast.error(lang === "EN" ? "Something went wrong" : "حدث خطأ ما");
    } finally {
      setIsAddingToCart((p) => ({ ...p, [product.id]: false }));
    }
  }, [isAddingToCart, addToCart, removeFromCart, isInCart, lang]);

  // ─── Product Card ─────────────────────────────────────
  const ProductCard = ({ product }) => {
    const uniqueColors    = getUniqueColors(product);
    const outOfStock      = isOutOfStock(product);
    const availableVariant = getAvailableVariant(product);
    const isWithoutBox    = availableVariant
      ? (availableVariant.quantity - availableVariant.reservedQuantity) <= 0
      : false;
    const productInCart   = availableVariant ? isInCart(availableVariant.id, isWithoutBox) : false;
    const hasDiscount     = product.discountPrice && product.discountPrice !== product.price;
    const discountPct     = hasDiscount
      ? Math.round(((product.price - product.discountPrice) / product.price) * 100)
      : 0;

    return (
      <div className="ts-card" onClick={() => openProductProfile(product)}>

        {/* ── Image ── */}
        <div className="ts-card__img-wrap">
          {/* Badges */}
          <span className="ts-card__badge ts-card__badge--trend">
            <Star size={11} fill="currentColor" />
            {lang === "EN" ? "Trend" : "ترند"}
          </span>

          {hasDiscount && (
            <span className="ts-card__badge ts-card__badge--discount">-{discountPct}%</span>
          )}

          {outOfStock && (
            <div className="ts-card__oos">
              <span>{lang === "EN" ? "Out of Stock" : "غير متوفر"}</span>
            </div>
          )}

          {availableVariant && (
            <div className="ts-card__wishlist" onClick={(e) => { e.preventDefault(); e.stopPropagation(); }}>
              <WishlistButton productVariantId={availableVariant.id} className="ts-card__wishlist-btn" />
            </div>
          )}

          <img
            src={product.imageUrl}
            alt={lang === "EN" ? product.nameEn : product.nameAr}
            className="ts-card__img"
          />
        </div>

        {/* ── Content ── */}
        <div className="ts-card__body">
          {product.brandImageUrl && (
            <img
              src={product.brandImageUrl}
              alt={lang === "EN" ? product.brandNameEn : product.brandNameAr}
              className="ts-card__brand-img"
            />
          )}

          <p className="ts-card__category">
            {lang === "EN" ? product.categoryNameEn : product.categoryNameAr}
          </p>

          <h3 className="ts-card__name">
            {lang === "EN" ? product.nameEn : product.nameAr}
          </h3>

          {(product.descriptionEn || product.descriptionAr) && (
            <p className="ts-card__desc">
              {truncate(lang === "EN" ? product.descriptionEn : product.descriptionAr)}
            </p>
          )}

          {/* Colors */}
          {uniqueColors.length > 0 && (
            <div className="ts-card__colors">
              {uniqueColors.slice(0, 5).map((color, i) => (
                <span
                  key={i}
                  className="ts-card__color-dot"
                  style={{ backgroundColor: color.hexCode }}
                  title={lang === "EN" ? color.nameEn : color.nameAr}
                />
              ))}
              {uniqueColors.length > 5 && (
                <span className="ts-card__color-more">+{uniqueColors.length - 5}</span>
              )}
            </div>
          )}

          {/* Price */}
          <div className="ts-card__price">
            <span className="ts-card__price-current">
              {(product.discountPrice || product.price).toLocaleString()}
              <span className="ts-card__price-currency">{lang === "EN" ? " EGP" : " ج.م"}</span>
            </span>
            {hasDiscount && (
              <span className="ts-card__price-old">
                {product.price.toLocaleString()} {lang === "EN" ? "EGP" : "ج.م"}
              </span>
            )}
          </div>

          {/* Actions */}
          <div className="ts-card__actions">
            <button
              className={[
                "ts-card__btn-cart",
                productInCart   ? "is-in-cart"   : "",
                showSuccess[product.id] ? "is-success" : "",
                isAddingToCart[product.id] ? "is-loading" : "",
                outOfStock ? "is-oos" : "",
              ].filter(Boolean).join(" ")}
              onClick={(e) => handleCartAction(e, product)}
              disabled={isAddingToCart[product.id] || outOfStock}
            >
              {isAddingToCart[product.id] ? (
                <><div className="ts-btn-spinner" /><span>{lang === "EN" ? "Processing..." : "جاري..."}</span></>
              ) : showSuccess[product.id] ? (
                <><Check size={16} strokeWidth={2.5} /><span>{lang === "EN" ? "Added!" : "تمت!"}</span></>
              ) : outOfStock ? (
                <><ShoppingCart size={16} strokeWidth={2.5} /><span>{lang === "EN" ? "Out of Stock" : "غير متوفر"}</span></>
              ) : productInCart ? (
                <><ShoppingCart size={16} strokeWidth={2.5} /><span>{lang === "EN" ? "Remove" : "إزالة"}</span></>
              ) : (
                <><ShoppingCart size={16} strokeWidth={2.5} /><span>{lang === "EN" ? "Add to Cart" : "أضف للسلة"}</span></>
              )}
            </button>

            <button
              className="ts-card__btn-view"
              onClick={(e) => { e.stopPropagation(); openProductProfile(product); }}
              aria-label="View product"
            >
              <Eye size={16} strokeWidth={2.5} />
            </button>
          </div>
        </div>
      </div>
    );
  };

  // ─── Loading ──────────────────────────────────────────
  if (loading) {
    return (
      <div className="ts-slider ts-slider--loading" style={{ backgroundImage: "url('/assets/black background.jpg')" }}>
        <div className="ts-loader">
          <div className="ts-loader__spinner" />
          <p>{lang === "EN" ? "Loading Trending Products..." : "جاري تحميل المنتجات الرائجة..."}</p>
        </div>
      </div>
    );
  }

  if (!products.length) {
    return (
      <div className="ts-slider ts-slider--empty" style={{ backgroundImage: "url('/assets/black background.jpg')" }}>
        <p>{lang === "EN" ? "No trending products available" : "لا توجد منتجات متاحة"}</p>
      </div>
    );
  }

  // ─── Render ───────────────────────────────────────────
  return (
    <div className="ts-slider" style={{ backgroundImage: "url('/assets/black background.jpg')" }}>

      {/* Header */}
      <div className="ts-slider__header">
        <TrendingUp size={28} className="ts-slider__icon" />
        <h2 className="ts-slider__title">
          {lang === "EN" ? "Trending Now" : "الترند الآن"}
        </h2>
        <Sparkles size={28} className="ts-slider__icon" />
      </div>

      {/* Track + Arrows */}
      <div className="ts-slider__stage">
        <button
          className={`ts-slider__arrow ts-slider__arrow--left${canScrollLeft ? " is-visible" : ""}`}
          onClick={() => scroll("left")}
          aria-label={lang === "EN" ? "Previous" : "السابق"}
        >
          <ChevronLeft size={22} strokeWidth={2.5} />
        </button>

        <div className="ts-slider__track" ref={containerRef}>
          {products.map((product, i) => (
            <ProductCard key={`${product.id}-${i}`} product={product} />
          ))}
        </div>

        <button
          className={`ts-slider__arrow ts-slider__arrow--right${canScrollRight ? " is-visible" : ""}`}
          onClick={() => scroll("right")}
          aria-label={lang === "EN" ? "Next" : "التالي"}
        >
          <ChevronRight size={22} strokeWidth={2.5} />
        </button>
      </div>
    </div>
  );
};

export default HeroTrendingProductSlider;